import { useState } from 'react';

import { StyledToggleContent } from '@/components/shared/data-display/toggle';
import { Toggle } from '@/components/shared/data-display/toggle-compare';
import { Text } from '@/components/shared/element/text';

interface MaintenanceListRemarkProps {
  htmlContent: string;
  isDefaultOpen?: boolean;
}

export const MaintenanceListRemark = (props: MaintenanceListRemarkProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(!!props.isDefaultOpen);
  return (
    <Toggle
      title="หมายเหตุ"
      isOpen={isOpen}
      variant="white"
      onToggle={setIsOpen}
      css={{
        borderRadius: '$rounded-2',
      }}
    >
      <StyledToggleContent>
        <Text
          as="div"
          size="text-body-2"
          wrap
          dangerouslySetInnerHTML={{
            __html: props.htmlContent,
          }}
        />
      </StyledToggleContent>
    </Toggle>
  );
};

MaintenanceListRemark.displayName = 'SectionMaintenanceListRemark';
